import { render, staticRenderFns } from "./deporder_fdle_config.vue?vue&type=template&id=b7f713be&"
import script from "./deporder_fdle_config.vue?vue&type=script&lang=js&"
export * from "./deporder_fdle_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports